import React from 'react';
import classnames from 'classnames';
import { FormControl, Panel } from 'react-bootstrap';
import { useStateValue } from '../../context/state.jsx';
import { setProjectFilterSearchText } from '../../context/projectFilter.js';

const FilterByTaskName = () => {
	const [{ projectFilter }, dispatch] = useStateValue();
	const { searchText } = projectFilter;
	const handleSearchTextChange = e => {
		dispatch(setProjectFilterSearchText(e.target.value));
	};

	return (
		<Panel
			className={classnames({activeFilter: searchText !== ''})}>
			<Panel.Heading>
				<Panel.Title toggle>Activity ID / Name</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<FormControl
						type="text"
						value={searchText}
						placeholder="Filter by activity ID or name"
						onChange={handleSearchTextChange} />
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByTaskName;
